import React from 'react';
import PropTypes from 'prop-types';

import ProfileHeader from '../../components/employerProfile/ProfileHeader';

export default function PreviewProfileHeader({ background }) {
    function getProfileBg() {
        if (background) {
            return {
                backgroundImage: `url(${background})`,
            };
        }
    }

    return <ProfileHeader style={getProfileBg()} />;
}

PreviewProfileHeader.propTypes = {
    background: PropTypes.string,
};
